import {
  UPDATE_USER_LOGIN_INFO,
  REMOVE_USER_LOGIN_INFO,
  UPDATE_USER_OBJECT,
  UPDATE_USER_CHILDREN,
  UPDATE_USER_LANGUAGE
} from './mutation-types'

const baseUrl = ENV.API_BASE_URL.trim().replace(/\/$/, '')

function _getUrl (path) {
  return `${baseUrl}/${path.trim().replace(/^\//, '')}`
}

const actions = {
  createUser ({ state }, data) {
    const api = _getUrl('sign-up')
    const payload = {
      email: data.email,
      firstName: data.firstName,
      lastName: data.lastName,
      language: data.language,
      password: data.password,
      password2: data.password2,
      acceptPrivacyStmt: data.acceptPrivacyStmt,
      acceptedTOC: data.acceptedTOC,
      acceptedAnonDataRes: data.acceptedAnonDataRes,
      acceptReceiveEmail: data.acceptReceiveEmail
    }

    return this.$http.post(api, payload)
  },
  login ({ commit, state }, data) {
    const api = _getUrl('login')
    const payload = {
      email: data.email,
      password: data.password,
      language: data.language
    }

    return this.$http.post(api, payload)
      .then(resp => {
        console.log('resp', resp)
        commit(UPDATE_USER_LOGIN_INFO, resp.data.data)
        return resp
      })
  },
  logout ({ commit, state }) {
    const api = _getUrl('logout')
    const headers = {
      'Authorization': state.userToken
    }

    return this.$http.post(api, null, {headers})
      .then(resp => {
        commit(REMOVE_USER_LOGIN_INFO)
        return resp
      })
  },
  refreshUserInfo ({ commit, state }) {
    const api = _getUrl('users/me')
    const headers = {
      'Authorization': state.userToken
    }

    return this.$http.get(api, {headers})
      .then(resp => {
        commit(UPDATE_USER_OBJECT, resp.data.data)
      })
  },
  refreshChildList ({ commit, state }) {
    const headers = {
      'Authorization': state.userToken
    }

    return this.$http.all([
      this.$http.get(_getUrl('child'), {headers}),
      this.$http.get(_getUrl('assessment'), {headers})
    ])
      .then(
        this.$http.spread((childListResp, assListResp) => {
          commit(UPDATE_USER_CHILDREN, {childList: childListResp.data.data, assessmentList: assListResp.data.data})
        })
      )
  },
  addChild ({ state, dispatch }, data) {
    const api = _getUrl('child')
    const payload = {
      firstName: data.firstName,
      lastName: data.lastName,
      birthDate: data.birthDate,
      gender: data.gender,
      birthWeek: data.birthWeek,
      hasAutismSiblings: data.hasAutismSiblings,
      permitToCarryAss: data.permitToCarryAss,
      acceptedAnonDataRes: data.acceptedAnonDataRes
    }

    const headers = {
      'Authorization': state.userToken
    }

    return this.$http.post(api, payload, {headers})
      .then((resp) => {
        dispatch('refreshChildList')
        return Promise.resolve(resp)
      })
  },
  submitAssessment ({ state, dispatch }, data) {
    const api = _getUrl(`assessment/${data.assessment.key}`)

    const payload = Object.assign({}, data.assData)

    const headers = {
      'Authorization': state.userToken
    }

    return this.$http.post(api, payload, {headers})
      .then((resp) => {
        dispatch('refreshChildList')
        return Promise.resolve(resp)
      })
  },
  requestPasswordReset (context, data) {
    const api = _getUrl('request-password-reset')
    const payload = {
      email: data.email,
      language: data.language
    }

    return this.$http.post(api, payload)
      .then(resp => {
        return resp
      })
  },
  updateUserLanguage ({ state, commit }, data) {
    const api = _getUrl('users/me/change-language')
    const payload = {
      language: data.language
    }

    const headers = {
      'Authorization': state.userToken
    }

    return this.$http.post(api, payload, {headers})
      .then(resp => {
        commit(UPDATE_USER_LANGUAGE, data.language)
        return resp
      })
  },
  updateEmailPreference ({ state }, data) {
    const api = _getUrl('users/me/email-comm-pref')
    const payload = {
      pref: data.pref
    }

    const headers = {
      'Authorization': state.userToken
    }

    return this.$http.post(api, payload, {headers})
      .then(resp => {
        return resp
      })
  },
  deleteUserProfile ({ state, commit }) {
    const api = _getUrl('users/me/delete-profile')

    const headers = {
      'Authorization': state.userToken
    }

    return this.$http.post(api, null, {headers})
      .then(resp => {
        commit(REMOVE_USER_LOGIN_INFO)
        return resp
      })
  },
  getAvailableLanguages () {
    const api = _getUrl('firebase-config/languages')

    return this.$http.get(api)
  },
  getLanguageTranslation () {
    const api = _getUrl('firebase-config/translation')

    return this.$http.get(api)
  },
  getAssessmentConfig () {
    const api = _getUrl('firebase-config/assessments')

    return this.$http.get(api)
  }
}

export default actions



// WEBPACK FOOTER //
// ./src/store/actions.js